if (!customElements.get('kr-product-videos')) {
  customElements.define('kr-product-videos', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.rail = this.querySelector('[data-video-rail]');
      this.dialog = this.querySelector('dialog');
      this.holder = this.querySelector('[data-video-player]');
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-video-id]');
        if (trigger) this.openVideo(trigger);
        if (event.target.closest('[data-video-close]')) this.dialog.close();
        if (event.target.closest('[data-video-prev]')) this.moveRail(-1);
        if (event.target.closest('[data-video-next]')) this.moveRail(1);
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.holder.replaceChildren();
        this.activeTrigger?.focus({preventScroll: true});
      }, options);
      this.rail.addEventListener('scroll', () => this.updateArrows(), options);
      this.resizeObserver = new ResizeObserver(() => this.updateArrows());
      this.resizeObserver.observe(this.rail);
      this.updateArrows();
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.holder?.replaceChildren();
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }
    openVideo(trigger) {
      const id = trigger.dataset.videoId;
      if (!/^[\w-]{11}$/.test(id)) return;
      if (typeof this.dialog.showModal !== 'function') {
        window.open('https://www.youtube.com/watch?v=' + id, '_blank', 'noopener');
        return;
      }
      this.activeTrigger = trigger;
      this.querySelector('[data-video-dialog-title]').textContent = trigger.dataset.videoTitle;
      this.querySelector('[data-video-watch]').href = 'https://www.youtube.com/watch?v=' + id;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0';
      frame.title = trigger.dataset.videoTitle;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      this.holder.replaceChildren(frame);
      this.dialog.showModal();
    }
    moveRail(direction) {
      this.rail.scrollBy({left: direction * this.rail.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    updateArrows() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      this.querySelector('[data-video-prev]').disabled = this.rail.scrollLeft <= 1;
      this.querySelector('[data-video-next]').disabled = this.rail.scrollLeft >= max - 1;
    }
  });
}
